import { render, staticRenderFns } from "./SellerModal.vue?vue&type=template&id=70b579b2"
import script from "./SellerModal.vue?vue&type=script&lang=js"
export * from "./SellerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports